// src/components/AppFooter.jsx
export default function AppFooter({ branding = {} }) {
  const year = new Date().getFullYear();
  return (
    <footer className="app-footer">
      <span>{branding.footerText || `© ${year} Pinch Point`}</span>
      <nav className="app-footer-links" aria-label="Legal">
        <a href="/terms" target="_blank" rel="noopener noreferrer" className="app-footer-link">Terms</a>
        <a href="/privacy" target="_blank" rel="noopener noreferrer" className="app-footer-link">Privacy</a>
        <a href="/eula" target="_blank" rel="noopener noreferrer" className="app-footer-link">EULA</a>
        <a href="/security" target="_blank" rel="noopener noreferrer" className="app-footer-link">Data Security</a>
        <a href="/data-choices" target="_blank" rel="noopener noreferrer" className="app-footer-link">Limit Use of My Data</a>
      </nav>
    </footer>
  );
}
